import type { OrderFinancialVO } from "../OrderForms/orders";

function hasConcreteNumber(value: unknown): value is number {
  return typeof value === "number" && Number.isFinite(value);
}

export function ensureZuuStep2DefaultValues(
  financial: OrderFinancialVO | undefined,
  options: { showRetirementFields?: boolean } = {},
): OrderFinancialVO {
  const current = financial ?? {};
  let changed = false;

  const next: OrderFinancialVO = {
    ...current,
  };

  const ensureSection = <K extends keyof OrderFinancialVO>(sectionKey: K) => {
    if (next[sectionKey]) {
      return next[sectionKey] as NonNullable<OrderFinancialVO[K]>;
    }

    const section = {
      ...((current[sectionKey] as Record<string, unknown> | undefined) || {}),
    } as NonNullable<OrderFinancialVO[K]>;
    next[sectionKey] = section;
    return section;
  };

  const ensureNumberField = <K extends keyof OrderFinancialVO>(
    sectionKey: K,
    fieldKey: string,
  ) => {
    const currentSection = (current[sectionKey] as Record<string, unknown> | undefined) || {};
    if (hasConcreteNumber(currentSection[fieldKey])) {
      return;
    }

    const nextSection = ensureSection(sectionKey) as Record<string, unknown>;
    if (!hasConcreteNumber(nextSection[fieldKey])) {
      nextSection[fieldKey] = 0;
      changed = true;
    }
  };

  ensureNumberField("income", "avgMonthlyIncome");
  ensureNumberField("expense", "avgMonthlyExpense");
  ensureNumberField("currentAssets", "currentLiquidAssets");

  if (options.showRetirementFields) {
    ensureNumberField("income", "expectedRetireIncome");
    ensureNumberField("currentAssets", "expectedRetireLiquidAssets");
  }

  return changed ? next : current;
}
